import { CardOffer } from './types';

export type CardOfferAction =
  { kind: 'none' } | { kind: 'delete' } | { kind: 'put'; physical_card_enabled: boolean };

/** The one call that takes a benefit set from `baseline` to `desired`. The
 * physical flag means nothing without the card, so it is not compared then. */
export const cardOfferAction = (baseline: CardOffer, desired: CardOffer): CardOfferAction => {
  if (!desired.card_enabled) {
    return baseline.card_enabled ? { kind: 'delete' } : { kind: 'none' };
  }

  if (baseline.card_enabled && baseline.physical_card_enabled === desired.physical_card_enabled) {
    return { kind: 'none' };
  }

  return { kind: 'put', physical_card_enabled: desired.physical_card_enabled };
};
